import { GetterTree } from 'vuex'
import { AuthState } from './types'
import { RootState } from '../types'

export const getters: GetterTree<AuthState, RootState> = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  isTokenValid: state => state.tokenValid,
  user: state => state.user,
  connection: state => state.connection,
  wsConnectionActive: state => state.wsConnectionActive,
  userId: state => state.userData.id,
  isAdmin: state => state.userData.isAdmin,
  isMonitoring: state => state.userData.isMonitoring,
  userFullName: state => `${state.userData.name} ${state.userData.lastName}`,
  userFullNameLs: () => {
    const rawUser = localStorage.getItem('user')
    const user = rawUser ? JSON.parse(rawUser) : null
    return user ? `${user.name} ${user.last_name}` : ''
  },
  avatarImage: state => state.userData.avatarImage,
  userAvatarLs: () => {
  const avatar = localStorage.getItem('user_avatar')
  return avatar && avatar !== 'undefined' ? avatar : null
},
}
